@if (isInitialized && component && componentSome) {
  <oe-chart [title]="componentSome.displayName"
    [period]="service.historyPeriod.value">
    @switch (componentSome.type) {
      @case ('sum') {
        <sumChart [isOnlyChart]="true"></sumChart>
      }
      @case ('productionMeter') {
        <productionMeterChart [isOnlyChart]="true"></productionMeterChart>
      }
      @case ('charger') {
        <chargerChart [isOnlyChart]="true"></chargerChart>
      }
    }
  </oe-chart>
}
@if (isInitialized) {
  <oe-footer-subnavigation [backButton]="true"
  [navigationOptions]="navigationButtons"></oe-footer-subnavigation>
}
